/**
 * The initial questions to display when opening the FMP modal
 * @type {string[]}
 */
export const INITIAL_QUESTIONS = ['hello', 'get_custom_offer', 'can_deliver'];
export const INITIAL_QUESTIONS_HOURLY = ['hello_hourly', 'hourly_provide', 'can_deliver_hourly'];

/**
 * The initial questions to display when opening the FMP modal for voice-over sub-category
 * @type {string[]}
 */
export const INITIAL_QUESTIONS_VOICE_OVER = ['vo_main_need', 'vo_main_price', 'vo_main_tone'];
export const INITIAL_QUESTIONS_VOICE_OVER_HOURLY = [
    'vo_main_need_hourly',
    'vo_main_price_hourly',
    'vo_main_tone_hourly'
];

/**
 * The initial questions to display when opening the FMP modal for website-development sub-category
 * @type {string[]}
 */
export const INITIAL_QUESTIONS_WEBSITE_DEVELOPMENT = ['wd_main_need', 'wd_main_experience', 'wd_main_design'];
export const INITIAL_QUESTIONS_WEBSITE_DEVELOPMENT_HOURLY = [
    'wd_main_need_hourly',
    'hourly_provide_wd',
    'wd_main_design_hourly'
];

/**
 * Get the next questions according to the current question
 * @type {Object.<string, string[]>}
 */
export const QUESTION_TO_NEXT_QUESTIONS = {
    'hello': ['send_work_samples', 'can_deliver', 'have_experience'],
    'get_custom_offer': ['budget', 'can_deliver', 'send_work_samples'],
    'can_deliver': ['budget', 'order', 'send_work_samples'],
    'vo_main_need': ['vo_word_count', 'vo_price', 'vo_timeline'],
    'vo_main_price': ['vo_tone', 'vo_need', 'vo_timeline'],
    'vo_main_tone': ['vo_need', 'vo_timeline', 'vo_word_count'],
    'wd_main_need': ['wd_platform', 'wd_design', 'wd_timeline'],
    'wd_main_experience': ['wd_design', 'wd_need', 'wd_timeline'],
    'wd_main_design': ['wd_need', 'wd_timeline', 'wd_platform'],
    'hello_hourly': ['hourly_provide', 'send_work_samples', 'can_deliver'],
    'can_deliver_hourly': ['hourly_provide', 'budget', 'send_work_samples'],
    'vo_main_need_hourly': ['hourly_provide', 'vo_word_count', 'vo_price'],
    'vo_main_price_hourly': ['hourly_provide', 'vo_need', 'vo_timeline'],
    'vo_main_tone_hourly': ['hourly_provide', 'vo_timeline', 'vo_word_count'],
    'wd_main_need_hourly': ['hourly_provide', 'wd_platform', 'wd_timeline'],
    'wd_main_design_hourly': ['hourly_provide', 'wd_timeline', 'wd_platform'],
    'hourly_provide_wd': ['wd_main_experience', 'wd_timeline', 'wd_design'],
    'hourly_provide': ['get_custom_offer', 'can_deliver', 'send_work_samples']
};

export const HOURLY_SUFFIX = '_hourly';

/**
 * Maximum message length before we show the quick questions carousel instead of the list.
 *
 * For example, if the message length is `120` we will show the list.
 * If the message length is `160` we will show the carousel.
 *
 * @type {number}
 */
export const QUICK_QUESTIONS_CAROUSEL_MESSAGE_LENGTH_THRESHOLD = 130;

export const QUICK_QUESTIONS_HIDE_LENGTH_THRESHOLD = 200;

/**
 * Minimum element height for which we show the quick questions carousel instead of the list.
 *
 * For example, if the element height is `360px` we will show the carousel.
 * If the element height is `400px` we will show the list.
 *
 * @type {number}
 */
export const QUICK_QUESTIONS_CAROUSEL_HEIGHT_THRESHOLD = 380;

/**
 * All supported quick question view types.
 *
 * @type {Object<string>}
 */
export const QuickQuestionViewType = {
    LIST: 'list',
    Carousel: 'carousel'
};
